// DashboardDetails.tsx
import React, { useState } from "react";
import { Button, IconButton, InputBase, Paper } from "@mui/material";
import useDebounce from "../../../../hooks/useDebounce";
import { IconSearch, IconInfoRed } from "../../../../icons/Icon";
import ListData from "./ListData";
import { useDashboardData } from "./useDashboardData";
import styles from "./dashboardDetails.module.scss";
import Loader from "../../../loader/Loader";


const DashboardDetails: React.FC = () => {
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText, 800);

  const {
    loading,
    precomputedTableRows,
    openIndices,
    setOpenIndices,
    handleTabFiltersChange,
    handleUMExport,
    handleClientExport,
  } = useDashboardData(debouncedSearch);

  // Expand/collapse logic etc.

  return (
    <>
      <div className="white-box mb-12">
        <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">

          <div className="flex align-items-center">

            <Paper component="form" className={`search-input mr-12 ${styles.search}`}>
              <InputBase
                placeholder="Search Site or Cafe or Status"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <IconButton type="button" aria-label="search">
                <IconSearch />
              </IconButton>
            </Paper>
          </div>
          <div className="button-wrap flex align-items-center">
            <Button className="link-btn" onClick={() => setOpenIndices(precomputedTableRows.map((_, i) => i))}>
              Expand all
            </Button>
            <span className="divider"></span>
            <Button className="link-btn" onClick={() => setOpenIndices([])}>
              Collapse all
            </Button>
            <span className="divider"></span>
            <Button className="link-btn status red">
              <span className="mr-6 flex align-items-center">
                <IconInfoRed />
                {location.pathname === '/sitemanagerdashboard' ?
                  <ul className='status-dropdown'>
                    <li><span></span> N/A</li>
                    <li className='pending'><span></span> Pending</li>
                    <li className='mp-pending'><span></span> MP Pending</li>
                    <li className='mr-pending'><span></span> MR Pending</li>
                    <li className='submitted'><span></span> Submitted</li>
                  </ul>
                  :
                  <ul className='status-dropdown'>
                    <li><span></span> N/A</li>
                    <li className='saved'><span></span> Saved by Chef</li>
                    <li className='pending'><span></span> Pending by UM</li>
                    <li className='submitted'><span></span> Submitted by UM</li>
                  </ul>
                }
              </span>
              Planning Status
            </Button>
          </div>
        </div>
      </div>
      <div className="inner-contant kitchen-dashboard">
        {/* ListData: just an Accordion-like UI that renders DaypartDashboardTable per daypart */}
        <ListData
          openIndices={openIndices}
          handleToggle={(index: number) =>
            setOpenIndices((prev) =>
              prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
            )
          }
          menuPlans={precomputedTableRows}
          handleTabFiltersChange={handleTabFiltersChange}
          handleUMExport={handleUMExport}
          handleClientExport={handleClientExport}
        />
      </div>

      {loading && <div><Loader /></div>}
    </>
  );
};

export default DashboardDetails;
